import api from "../utils/axios";

export const authApi = {
    userRegistration: (formData) => api.post("/users/auth/registration/", formData),
    userLogin: async (formData) => {
        const res = await api.post("/users/auth/login-email/", formData);
        return res.data;
    },
    userLogout: () => api.post("/users/auth/logout/"),

    userForgotPassword: (email) => api.post("/users/auth/forgot-password/", email),
    validatePasswordToken: (uid, token) => api.get(`users/auth/reset-password/validate/${uid}/${token}/`),
    userResetPassword: (formData) => api.post("users/auth/reset-password/", formData),

    userData: () => api.get("/users/me/"),

    userTokenVerify: () => api.post("/users/token/verify/"),
    userTokenRefresh: () => "/users/token/refresh/",
};
